import React, { useEffect, useState, useMemo } from 'react';
import FileFilterInput from "../FileFilterInput"; // adjust path if needed
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router-dom';

import ActionDrawer from './components/ActionDrawer';

import './stylesheet.css';

import classNames from 'classnames';

import * as syncBackendActions from '../../actions/sync_backend';

const FileBrowser = ({
  path,
  listing,
  hasMore,
  isLoadingMore,
  syncBackendType,
  syncBackend,
  // INFO: This was required back when we had Google Drive support.
  // Leaving it here in case another sync backend requires it.
  // additionalSyncBackendState,
}) => {
  // Ensure we use the path without query string for backend calls
  const cleanPath = path ? String(path).split('?')[0] : '';

  // Request directory listing when path changes (use clean path)
  useEffect(() => {
    syncBackend.getDirectoryListing(cleanPath);
  }, [syncBackend, cleanPath]);



  useEffect(() => syncBackend.getDirectoryListing(path), [syncBackend, path]);

  // 1. Extract ?filter= from URL if present
  //const queryParams = new URLSearchParams(window.location.search);
  //const initialFilter = queryParams.get("filter") || "";

  // Read initial filter value from URL ?filter=...
  const initialFilter = (typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('filter') || ''
    : '');
  const [filter, setFilter] = useState(initialFilter);


///  const [setListing] = useState(null);

///  // Use cleanPath for fetching
///   useEffect(() => {
///     fetch(`/files${cleanPath}`)
///       .then((res) => res.json())
///       .then((data) => setListing(data));
///   }, [cleanPath]);


 // Keep filter state in URL so link + share works (replaceState to avoid history spam)
 useEffect(() => {
   if (typeof window === 'undefined') return;
   const params = new URLSearchParams(window.location.search);
   if (filter) params.set('filter', filter);
   else params.delete('filter');
   const newQuery = params.toString();
   const newUrl = `${window.location.pathname}${newQuery ? '?' + newQuery : ''}`;
   window.history.replaceState({}, '', newUrl);
 }, [filter]);




 /// const filteredFiles = useMemo(() => {
 ///   if (!listing) return [];               // <-- safeguard
 ///   if (!filter.trim()) return listing;    // no filter, return everything
 ///   const q = filter.toLowerCase();
 ///   return listing.filter(
 ///     (file) =>
 ///       (file.get('name') && file.get('name').toLowerCase().includes(q)) ||
 ///       (file.get('path') && file.get('path').toLowerCase().includes(q))
 ///   );
 /// }, [listing, filter]);

 // 4. Sync state back into URL (optional, when user types)
 ///    useEffect(() => {
 ///    const params = new URLSearchParams(window.location.search);
 ///      if (filter) {
 ///    params.set("filter", filter);
 ///  } else {
 ///    params.delete("filter");
 ///  }
 ///  const newUrl = `${window.location.pathname}?${params.toString()}`;
 ///  window.history.replaceState({}, "", newUrl);
 /// }, [filter]);





  const handleLoadMoreClick = () => syncBackend.loadMoreDirectoryListing();

  const getParentDirectoryPath = () => {
    switch (syncBackendType) {
      case 'Dropbox':
      case 'GitLab':
      case 'WebDAV':
        const pathParts = path.split('/');
        return pathParts.slice(0, pathParts.length - 1).join('/');
      default:
        return null;
    }

  };

  const isTopLevelDirectory = cleanPath === '';

  // Filter the listing safely. listing may be null while loading.
  const filteredListing = useMemo(() => {
    if (!listing) return [];
    if (!filter || !filter.trim()) return listing;
    const q = filter.toLowerCase();
    // listing is an Immutable List with .filter and .map; return same type when possible
    return listing.filter((file) => {
      const name = (file.get('name') || '').toLowerCase();
      const p = (file.get('path') || '').toLowerCase();
      return name.includes(q) || p.includes(q);
    });
  }, [listing, filter]);


  return (
    <div className="file-browser-container">
      {syncBackendType === 'Dropbox' && (
        <h3 className="file-browser__header">Directory: {isTopLevelDirectory ? '/' : path}</h3>
      )}


      <div className="file-browser__filter">
        <FileFilterInput
          value={filter}
          onChange={setFilter}
          placeholder="Filter files..."
          debounceMs={180}
        />
      </div>

     <ActionDrawer onFilterChange={setFilter} />

      <ul className="file-browser__file-list">
        {!isTopLevelDirectory && (
          <Link to={`/files${getParentDirectoryPath()}`}>
            <li className="file-browser__file-list__element">
              <i className="fas fa-folder file-browser__file-list__icon--directory" /> ..
            </li>
          </Link>
        )}

        {(filteredListing || []).map((file) => {
          const isDirectory = file.get('isDirectory');
          const isBackupFile = file.get('name').endsWith('.organice-bak');
          const isOrgFile = file.get('name').endsWith('.org');
          const isSettingsFile = file.get('name') === '.organice-config.json';

          const iconClass = classNames('file-browser__file-list__icon fas', {
            'fa-folder': isDirectory,
            'file-browser__file-list__icon--directory': isDirectory,
            'fa-file': !isDirectory && !isBackupFile && !isSettingsFile,
            'file-browser__file-list__icon--not-org': !isOrgFile,
            'fa-copy': isBackupFile,
            'fa-cogs': isSettingsFile,
          });

          if (file.get('isDirectory')) {
            return (
              <Link to={`/files${file.get('path')}`} key={file.get('id')}>
                <li className="file-browser__file-list__element">
                  <i className={iconClass} /> {file.get('name')}/
                </li>
              </Link>
            );
          } else {
            return (
              <Link to={`/file${file.get('path')}`} key={file.get('id')}>
                <li className="file-browser__file-list__element">
                  <i className={iconClass} /> {file.get('name')}
                </li>
              </Link>
            );
          }
        })}

        {hasMore &&
          (isLoadingMore ? (
            <li className="file-browser__file-list__loading-more-container">
              <i className="fas fa-spinner fa-lg fa-spin" />
            </li>
          ) : (
            <li
              className="file-browser__file-list__element file-browser__file-list__element--load-more-row"
              onClick={handleLoadMoreClick}
            >
              Load more...
            </li>
          ))}
      </ul>
    </div>
  );
};

const mapStateToProps = (state) => {
  const currentFileBrowserDirectoryListing = state.syncBackend.get(
    'currentFileBrowserDirectoryListing'
  );
  return {
    syncBackendType: state.syncBackend.get('client').type,
    listing: !!currentFileBrowserDirectoryListing
      ? currentFileBrowserDirectoryListing.get('listing')
      : null,
    hasMore:
      !!currentFileBrowserDirectoryListing && currentFileBrowserDirectoryListing.get('hasMore'),
    isLoadingMore:
      !!currentFileBrowserDirectoryListing &&
      currentFileBrowserDirectoryListing.get('isLoadingMore'),
    additionalSyncBackendState:
      !!currentFileBrowserDirectoryListing &&
      currentFileBrowserDirectoryListing.get('additionalSyncBackendState'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    syncBackend: bindActionCreators(syncBackendActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileBrowser);
